import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatRadioModule } from '@angular/material/radio';
import { OrganizationRiderServiceLevelsComponent } from './organization-rider-service-levels.component';

@NgModule({
  imports: [CommonModule, MatRadioModule],
  exports: [OrganizationRiderServiceLevelsComponent],
  declarations: [OrganizationRiderServiceLevelsComponent]
})
export class OrganizationRiderServiceLevelsModule {}
